import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import Hero from '../components/Hero'
import HowWeWorks from '../components/HowWeWorks'
import ProductCateloge from '../components/ProductCateloge'
import IndustriesSection from '../components/IndustriesSection'
import AboutAndWhy from '../components/AboutAndWhy'
import GetQuoteSection from '../components/GetQuoteSection'
import Testimonials from '../components/Testimonials'
import FaqSection from '../components/FaqSection'

function Home() {
  const productRef = useRef(null);
  const industryRef = useRef(null);
  const location = useLocation();

  // scroll handler (used by Hero)
  const scrollToProducts = () => {
    productRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const map = {
      products: productRef,
      industries: industryRef,
    };

    const targetRef = map[location.state.scrollTo];

    setTimeout(() => {
      targetRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }, [location]);

  return (
    <>
      <Hero onProductClick={scrollToProducts} />

      <HowWeWorks />

      <section id="products">
        <ProductCateloge />
      </section>

      <section id="industries">
        <IndustriesSection />
      </section>

      <AboutAndWhy />
      <GetQuoteSection />
      <Testimonials />
      <FaqSection />
    </>
  )
}

export default Home;
